import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  '.label': {
    fontSize: rem(constants.fontSize.h4),
    color: theme.primary,
    fontWeight: 'bold',
    display: 'flex',
    marginBottom: constants.offset.small,
  },

  '.error-message': {
    marginTop: constants.offset.xsmall,
  },
};
